// @flow

import React from 'react';
import { SelectProps } from 'antd/lib/select';

import { placeApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
type Props = SelectProps & { filter: any };

export default ({ filter = {}, ...selectProps }: Props) => (
  <AutocompleteSelect
    fetch={async params => {
      return await placeApi.fetch({
        ...filter,
        ...params
      });
    }}
    refetchParams={{ filter }}
    fetchSingle={placeApi.get}
    notFoundText="Местоположения не найдены"
    placeholder="Выберите местоположение"
    renderOption={(place: any, Option) => (
      <Option key={place.id} value={place.id} place={place}>
        {place.fullName}
      </Option>
    )}
    {...selectProps}
  />
);
